import { Loader2 } from 'lucide-react'

import { Button } from '@/components/ui/button'

import type { ButtonProps } from '@/components/ui/button'

export type LoadingButtonProps = ButtonProps & {
	isLoading: boolean
	ref?: React.Ref<HTMLButtonElement | null>
}

/**
 * A button that shows a loading spinner when the button is clicked.
 *
 * Accept the same props as shadcn Button
 *
 * @param isLoading - Whether the button is loading
 *
 * @example
 * <LoadingButton isLoading={true}>Submit</LoadingButton>
 */
export const LoadingButton = ({
	ref,
	isLoading,
	children,
	...props
}: LoadingButtonProps) => {
	return (
		<Button disabled={isLoading || props.disabled} {...props} ref={ref}>
			{isLoading ? (
				<Loader2 className="repeat-infinite h-6 w-6 animate-spin" />
			) : (
				children
			)}
		</Button>
	)
}
